import { useState, useEffect } from 'react'
import ModalBootstrap from 'react-bootstrap/Modal'
import { X } from 'react-feather'
import * as S from './PkModal.styles'
import { useSelector } from 'src/utils/store'
import CircularProgress from '@mui/material/CircularProgress'
import { Box, Typography } from '@mui/material'

interface ModalProps {
  show: boolean
  backgroundColor: string
  title: string
  testId?: string
  body: JSX.Element
  zindex?: number,
  closedButton?: boolean
  cancelButtonText?: string
  cancelButtonColor: string
  cancelButtonHoverColor: string
  closeButtonAction?: any
  confirmButtonText?: string
  confirmButtonColor: string
  confirmButtonHoverColor: string
  onConfirm: () => any
  onReject: () => any
  onClose: () => any
}

export const PkModal = ({
  show = false,
  backgroundColor,
  testId,
  title,
  body,
  zindex,
  cancelButtonText,
  cancelButtonColor,
  cancelButtonHoverColor,
  confirmButtonText,
  confirmButtonColor,
  confirmButtonHoverColor,
  closedButton = true,
  closeButtonAction = () => ({}),
  onConfirm,
  onReject,
  onClose,
}: ModalProps) => {
  const stockMovements = useSelector((state) => state.stockMovements)
  const {
    pkModalDisableButtons,
  } = stockMovements

  const [isShow, setIsShow] = useState(show)

  useEffect(() => {
    setIsShow(show)
  }, [show])

  const handleIsShow = () => setIsShow((prevState) => !prevState)

  return (
    <S.Modal
      show={isShow}
      backdrop='static'
      onHide={() => {
        setIsShow(false)
        closeButtonAction()
      }}
      centered
      data-testid={testId}
      zindex={zindex || 1040}
    >
      <S.ModalHeader color={backgroundColor}>
        <S.TitleContainer>
          <ModalBootstrap.Title>
            {title}
          </ModalBootstrap.Title>
        </S.TitleContainer>
        {closedButton && (
        <S.ExitButton
          aria-label='fechar'
          onClick={onClose || handleIsShow}
          data-testid='pk-close-button-test'
        >
          <X />
        </S.ExitButton>
        )}
      </S.ModalHeader>
      <ModalBootstrap.Body style={{ padding: 0 }}>
        <S.ModalBody>
          {body}
        </S.ModalBody>
      </ModalBootstrap.Body>
      <S.ModalFooter color={backgroundColor}>
        <S.CancelButton
          color={cancelButtonColor}
          hoverColor={cancelButtonHoverColor}
          onClick={onReject}
          data-testid='pk-cancel-button-test'
          disabled={pkModalDisableButtons}
        >
          {pkModalDisableButtons
            ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
                <CircularProgress size={28} sx={{ color: '#FFF' }}/>
                <Typography>Aguarde...</Typography>
              </Box>
            )
            : (<>{cancelButtonText ?? 'Cancelar'}</>)}
        </S.CancelButton>
        <S.ConfirmButton
          color={confirmButtonColor}
          hoverColor={confirmButtonHoverColor}
          onClick={onConfirm}
          data-testid='pk-confirm-button-test'
          disabled={pkModalDisableButtons}
        >
          {pkModalDisableButtons
            ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '.4rem' }}>
                <CircularProgress size={28} sx={{ color: '#FFF' }}/>
                <Typography>Aguarde...</Typography>
              </Box>
            )
            : (<>{confirmButtonText ?? 'Confirmar'}</>)}
        </S.ConfirmButton>
      </S.ModalFooter>
    </S.Modal>
  )
}
